import { Helmet } from "react-helmet-async";
import CitySelector from "@/components/CitySelector";
import SpotlightRow from "@/components/SpotlightRow";
import ProfileCard from "@/components/ProfileCard";
import AdSlot from "@/components/AdSlot";
import { Button } from "@/components/ui/button";

export default function Index() {
  return (
    <main className="min-h-screen w-full">
      <Helmet>
        <title>FANZ — Discover & Boost</title>
        <meta name="description" content="Discover creators by city with spotlight placements and compliant ads." />
        <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : 'https://example.com/'} />
      </Helmet>
      <section className="mx-auto max-w-6xl px-4 pt-16 pb-10 text-center space-y-6">
        <h1 className="text-3xl md:text-5xl font-semibold">Find creators near you</h1>
        <p className="text-sm text-muted-foreground">Search by city, filter by availability, and boost visibility.</p>
        <div className="flex items-center justify-center">
          <CitySelector onChange={() => {}} />
        </div>
        <div className="flex items-center justify-center gap-3">
          <Button asChild><a href="/search">Search</a></Button>
          <Button variant="secondary" asChild><a href="/boost">Boost a profile</a></Button>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 space-y-4">
        <h2 className="text-lg font-medium">Spotlight</h2>
        <SpotlightRow />
      </section>

      <section className="mx-auto max-w-6xl px-4 py-8 space-y-4">
        <h2 className="text-lg font-medium">Trending near you</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {Array.from({ length: 16 }).map((_, i) => (
            i % 8 === 6 ? (
              <AdSlot key={`ad-${i}`} zoneId="grid-inline" />
            ) : (
              <ProfileCard key={i} />
            )
          ))}
        </div>
      </section>
    </main>
  );
}